import normalVertex from  '../shader/v/normal.vert';
import videoFragment from '../shader/f/video.frag';
import imageFragment from '../shader/f/image.frag';
import mapFragment from '../shader/f/map.frag';

export default class DOMGL {

	constructor(prop = {}) {

		//
		this.prop = prop;

		//
		this.timer = null;
		this.onmouse = false;
		this.shown = false;
		this.visible = false;

		//
		this.map = {
			mesh : null,
			program : null,
			geometry : null
		};

		//
		this.screen = {
			mesh : null,
			program : null,
			geometry : null
		};

		//
		this.autoplay = prop.autoplay ? prop.autoplay : false;
		this.alpha    = prop.alpha ? prop.alpha : 1;
		this.scroll   = prop.scroll;

		//
		this.rect = {
			x : 0,
			y : 0,
			width  : 0,
			height : 0
		}

		//
		this.translate = {
			x : 0,
			y : 0,
			rotate : {
				x : 0,
				y : 0,
				z : 0
			}
		}

		//
		this.onInit();
		this.onResize();

	}

	onUpdateProp(){
		this.screen.mesh.program.uniforms.u_alpha.value = this.alpha;
	}

	onInit(){

		//
		this.posterTexture = null;
		this.thumbTexture  = null;
		this.videoTexture  = null;

		//
		if( this.prop.poster ){
			this.posterTexture = new OGL.Texture( WEBGL.gl, {
				generateMipmaps: false,
				// premultiplyAlpha : false,
				format : WEBGL.gl.RGB
			});			
		}

		//
		this.thumbTexture = new OGL.Texture( WEBGL.gl, {
			generateMipmaps: false,
			// premultiplyAlpha : false,
			format : WEBGL.gl.RGB
		});

		//
		if( this.prop.video.el ){
			this.videoTexture = new OGL.Texture( WEBGL.gl, {
				generateMipmaps: false,
				// premultiplyAlpha : false,
				format : WEBGL.gl.RGB
			});
		}

		//
		this.screen.geometry = new OGL.Plane( WEBGL.gl,{ width  : 1, height : 1 });

		//
		const fragment = this.prop.video.el ? videoFragment : imageFragment;

		//
		const uniforms = {
			tColor  : { value: COLOR[ this.prop.color ].bg.ogl },
			tPoster : { value: this.posterTexture },
			tThumb  : { value: this.thumbTexture },
			tVideo  : { value: this.videoTexture },
			u_alpha : { value: this.alpha },
			u_power_thumb : { value: 0 },
			u_power_video : { value: 0 },
			i_resolution : { value : new OGL.Vec2( 0.0, 0.0 ) },
			uv_resolution : { value : new OGL.Vec2( 0.0, 0.0 ) }
		}

		//
		this.screen.program = new OGL.Program( WEBGL.gl, {
			vertex: normalVertex,
			fragment : fragment,
			transparent : false,
			cullFace : null,
			// depthWrite  : true,
			depthTest : false,
			depthWrite : false,
			uniforms : uniforms,
		});
		this.screen.mesh = new OGL.Mesh( WEBGL.gl, { geometry : this.screen.geometry, program : this.screen.program });
		this.screen.mesh.setParent( WEBGL.scene );
		this.screen.mesh.visible = true;

		//
		this.map.geometry = new OGL.Plane( WEBGL.gl,{ width  : 1, height : 1 });
		this.map.program = new OGL.Program( WEBGL.gl, {
			vertex: normalVertex,
			fragment : mapFragment,
			transparent : false,
			depthTest : false,
			depthWrite : false,
			cullFace : null,
		});
		this.map.mesh = new OGL.Mesh( WEBGL.gl, { geometry : this.screen.geometry, program : this.map.program });
		this.map.mesh.setParent( WEBGL.map );
		this.map.mesh.visible = true;

	}

	onMouseEnter(){
		// clearTimeout( this.timer );
		this.onmouse = true;
	}

	onPlay(){

		if( !this.autoplay && this.screen.mesh.program.uniforms.u_power_thumb.value === 1 && this.prop.video.canplay.flg && this.prop.video.el.paused && this.onmouse && this.prop.thumb.isloaded ){
			onPlayVideo( this.prop.video.el );
		}

		if( this.prop.video.playing.flg ){
			if( this.prop.video.el.currentTime >= 0.1 ){
				this.screen.mesh.program.uniforms.u_power_video.value = 1;
			}
		} else {
			this.screen.mesh.program.uniforms.u_power_video.value = 0;				
		}

	}

	onMouseLeave(){
		this.onmouse = false;
		if( this.prop.video.el ){
			// clearTimeout( this.timer );
			this.prop.video.el.pause();
		}
	}

	onReset(){

		//
		const isHome = pageTransition.current.name === this.prop.name && pageTransition.current.name === 'home';
		const isSingle = pageTransition.current.postId === this.prop.postId;
		if( isHome || isSingle ){
			this.onResize();
		} else {
			this.onmouse = false;
			this.screen.mesh.visible = this.map.mesh.visible = false;
			if( this.prop.video.el && !this.prop.video.el.paused ){
				if( this.prop.name != 'home' ) this.prop.video.el.currentTime = 0;
				this.prop.video.el.pause();
			}
			if( this.prop.video.el && this.prop.name != 'home' ){
				this.prop.video.playing.flg = false;
				this.screen.mesh.program.uniforms.u_power_video.value = 0;
			}
		}

	}

	onDestroy(){

		//
		if( this.prop ) this.prop.onDestroy(); this.prop = null;

		//
		this.screen.mesh.geometry.remove();
		this.screen.mesh.geometry = null;
		this.screen.geometry = null;
		this.screen.mesh.program.remove();
		this.screen.mesh.program = null;
		this.screen.program = null;

		//
		this.map.mesh.geometry.remove();
		this.map.mesh.geometry = null;
		this.map.geometry = null;
		this.map.mesh.program.remove();
		this.map.mesh.program = null;
		this.map.program = null;

		//
		if( this.posterTexture ){
			WEBGL.gl.deleteTexture(this.posterTexture.texture);
			this.posterTexture = null;
		}
		if( this.thumbTexture ){
			WEBGL.gl.deleteTexture(this.thumbTexture.texture);
			this.thumbTexture = null;
		}
		if( this.videoTexture ){
			WEBGL.gl.deleteTexture(this.videoTexture.texture);
			this.videoTexture = null;
		}

		//
		WEBGL.scene.removeChild(this.screen.mesh);
		this.screen.mesh = null;

		//
		WEBGL.map.removeChild(this.map.mesh);
		this.map.mesh = null;
		
	}

	onLoadPoster(){
		if( !this.prop.poster.isloading && this.posterTexture.image != this.prop.poster.el && this.prop.poster.isloaded ){
			this.prop.poster.isloading = true;
			this.prop.poster.el.src = this.prop.poster.src;
			this.prop.poster.el.onload = () => {
				this.prop.poster.isloaded = true;
				this.posterTexture.image = this.prop.poster.el;
			};
		}
	}

	onLoadThumb(){

		// Poster
		// if( !this.prop.thumb.isloading && this.shown && this.prop.poster.isloaded ){
		if( !this.prop.thumb.isloading && this.shown ){

			//
			this.prop.thumb.isloading = true;

			//
			if( !this.prop.thumb.isloaded ){
				this.prop.thumb.el.src = this.prop.thumb.src;
				this.prop.thumb.el.onload = () => {
					this.prop.thumb.isloaded = true;
					this.thumbTexture.image = this.prop.thumb.el;
					// Poster
					if( this.screen.mesh.program.uniforms.u_power_thumb && this.prop.poster ){
						gsap.to( this.screen.mesh.program.uniforms.u_power_thumb, {
							duration : .5,
							ease : 'power2.out',
							value : 1
						});
					}
				};
			} else {
				this.prop.thumb.isloaded = true;
				this.thumbTexture.image = this.prop.thumb.el;
				// Poster
				if( this.screen.mesh.program.uniforms.u_power_thumb && this.prop.poster ){
					gsap.to( this.screen.mesh.program.uniforms.u_power_thumb, {
						duration : .5,
						ease : 'power2.out',
						value : 1
					});
				}
			}
		}

	}

	onLoadVideo(){

		if( this.screen.mesh.visible ){

			if( this.shown ){

				if( this.prop.video.el.preload != "metadata"){
					this.prop.video.el.preload = "metadata";
				}

				if ( this.prop.video.el.readyState >= this.prop.video.el.HAVE_ENOUGH_DATA ) {

					//
					if( !this.videoTexture.image ) this.videoTexture.image = this.prop.video.el;

					//==================
					// UPDATE
					//==================
					if( !this.prop.video.el.paused ){
						if( !this.videoTexture.needsUpdate ) this.videoTexture.needsUpdate = true;
					} else {
						this.videoTexture.needsUpdate = false;
					}

					//==================
					// ABOUT
					//==================
					if( this.prop.video.el.paused ){
						if( this.autoplay ){
							if( this.prop.video.canplay.flg ){
								onPlayVideo( this.prop.video.el );
								this.screen.mesh.program.uniforms.u_power_video.value = 1;
							}
						}
					}

				}
			}

		} else {

			//==================
			// UPDATE
			//==================
			this.videoTexture.needsUpdate = false;

			//==================
			// ABOUT
			//==================
			if( this.autoplay && !this.prop.video.el.paused && this.prop.video.canplay.flg ){
				this.prop.video.el.pause();
			}

		}

	}

	onResize(){
		let _x =  this.rect.x + this.screen.mesh.scale.x/2 - WW/2 + this.translate.x;
		let _y = -this.rect.y + WH/2 - this.screen.mesh.scale.y/2 + this.translate.y;
		if( this.screen.mesh.scale.x != this.rect.width || this.screen.mesh.position.y != _y ){
			this.screen.mesh.scale.x    = this.map.mesh.scale.x    = this.rect.width;
			this.screen.mesh.scale.y    = this.map.mesh.scale.y    = this.rect.height;
			this.screen.mesh.position.x = this.map.mesh.position.x = _x;
			this.screen.mesh.position.y = this.map.mesh.position.y = _y;
			if( this.screen.mesh.program.uniforms.uv_resolution.value[0] != this.screen.mesh.scale.x ){
				this.screen.mesh.program.uniforms.uv_resolution.value[0] = this.screen.mesh.scale.x;
				this.screen.mesh.program.uniforms.uv_resolution.value[1] = this.screen.mesh.scale.y;
			}
			if( this.screen.mesh.program.uniforms.i_resolution.value[0] != this.prop.width ){
				this.screen.mesh.program.uniforms.i_resolution.value[0] = this.prop.width;
				this.screen.mesh.program.uniforms.i_resolution.value[1] = this.prop.height;
			}
		}

	}


	onUpdate( rect = { width:0, height:0, x:0, y:0 } ){
		this.rect = rect;
		this.onResize();
	}

	onRender( o = { shown:false, visible:false } ){
		this.shown = o.shown;
		this.visible = o.visible;
		this.screen.mesh.visible = this.map.mesh.visible = this.visible;
		if( this.prop.poster ) this.onLoadPoster();
		if( this.prop.thumb ) this.onLoadThumb();
		if( this.prop.video.el ) this.onLoadVideo();
		if( this.prop.poster && this.prop.video.el ) this.onPlay();
	}

	onMouseMove( x = 0, y = 0, deg = 0 ){
		this.translate.x = x;
		this.translate.y = -y;
		let _x =  this.rect.x + this.screen.mesh.scale.x/2 - WW/2 + this.translate.x;
		let _y = -this.rect.y + WH/2 - this.screen.mesh.scale.y/2 + this.translate.y;
		this.screen.mesh.position.x = this.map.mesh.position.x = _x;
		this.screen.mesh.position.y = this.map.mesh.position.y = _y;
	}

	onScroll( rect = { width:0, height:0, x:0, y:0 } ){
		this.rect = rect;
		let _x =  this.rect.x + this.screen.mesh.scale.x/2 - WW/2 + this.translate.x;
		let _y = -this.rect.y + WH/2 - this.screen.mesh.scale.y/2 + this.translate.y;
		this.screen.mesh.position.x = this.map.mesh.position.x = _x;
		this.screen.mesh.position.y = this.map.mesh.position.y = _y;
	}

}









































